import { Component, OnInit, ViewChild } from '@angular/core';
import { CurrentDoctorService } from '@service/CurrentDoctorService';
import { PracticeDTO } from '@dto/doctor/PracticeDTO';
import { StateUtil } from '@util/StateUtil';
import { State } from '@common/State';
import { ApplicationModel } from '@model/ApplicationModel';
import { NgForm } from '@angular/forms';
import { ViewUtil } from '@util/ViewUtil';

@Component({
  selector: 'app-update-practice',
  templateUrl: './ProfilePracticeEditComponent.html',
  styleUrls: [ './ProfilePracticeEditComponent.scss' ]
})
export class ProfilePracticeEditComponent implements OnInit {
  @ViewChild('form') public form: NgForm;

  public practice: PracticeDTO;

  constructor(private currentDoctorService: CurrentDoctorService,
              private applicationModel: ApplicationModel,
              private viewUtil: ViewUtil,
              private stateUtil: StateUtil) {
    this.applicationModel.selectSideBarItemWithState(State.MAIN.PROFILE.BASIC_DATA);
  }

  public ngOnInit(): void {
    this.currentDoctorService.getPractice().toPromise()
      .then((practice: PracticeDTO) => {
        this.practice = practice;
      });
  }

  public save(): void {
    if (this.form.valid) {
      this.currentDoctorService.updatePractice(this.practice).toPromise()
        .then(() => {
          this.viewUtil.showToastSuccess('VIEW.MAIN.DOCTOR.PRACTICE.MESSAGE.UPDATE_SUCCESS');
          this.back();
        })
        .catch((error) => {
          this.viewUtil.handleServerError(error);
        });
    } else {
      this.viewUtil.showToastError('VALIDATION.FORM');
    }
  }

  public back(): void {
    this.stateUtil.goToState(State.MAIN.PROFILE.PRACTICE);
  }

}
